import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { appStrings } from '../../app.config';
import { FilterService } from '@shared/services/filters/filter.service';
import { Subscription } from 'rxjs';
import { ListTypes } from '@shared/models/listing';
import { FilterItem, FiltersStore } from '@shared/models/filters';
import { Store } from '@ngrx/store';
import { FiltersState } from '@shared/state/reducers/filters/filters.reducer';
import { selectFilters } from '@shared/state/selectors/filters/filters.selectors';

@Component({
    selector: 'marketplace-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {
  filtersFromStore: FiltersStore;
  filters: FilterItem[];
  listType: string;
  sidebarHeader: string;
  subFilters$: Subscription;
  subFiltersState$: Subscription;
  subRoute$: Subscription;
  subscriptionList = new Subscription();
  @Output() openedChange = new EventEmitter<boolean>();

  constructor(
    private _filterService: FilterService,
    private _router: Router,
    private _filtersStore: Store<FiltersState>
  ) {}

  ngOnInit() {
    this.getFiltersState();
  }

  /**
   * Check if inbox type is requests or quotes. Set headers and filters state accordingly
   */
  getListType() {
    const currentUrl: string = this._router.url;
    this.setListData(currentUrl);
    this.subRoute$ = this._router.events.subscribe(response => {
      if (response && response instanceof NavigationStart) {
        this.setListData(response.url);
      }
      this.closeSidebar();
    });
  }

  setListData(url: string) {
    if (url.includes(ListTypes.REQUESTS)) {
      this.listType = ListTypes.REQUESTS;
      this.sidebarHeader = appStrings.filters.filter_requests;
    } else if (url.includes(ListTypes.QUOTES)) {
      this.listType = ListTypes.QUOTES;
      this.sidebarHeader = appStrings.filters.filter_quotes;
    } else if (url.includes(ListTypes.BOOKINGS)) {
      this.listType = ListTypes.BOOKINGS;
      this.sidebarHeader = appStrings.filters.filter_bookings;
    } else if (url.includes(ListTypes.ENQUIRIES)) {
      this.listType = ListTypes.ENQUIRIES;
      this.sidebarHeader = 'Filter Enquiries';
    } else if (url.includes(ListTypes.CUSTOMERS)) {
      this.listType = ListTypes.CUSTOMERS;
      this.sidebarHeader = 'Filter Customers';
    } else {
      this.sidebarHeader = '';
      this.listType = ListTypes.OTHER;
    }
  }

  getFiltersState() {
    this.subFiltersState$ = this._filtersStore.select(selectFilters).subscribe(response => {
      if (response) {
        this.getListType();
        this.filtersFromStore = response;
      }
    });
  }

  closeSidebar() {
    this._filterService.toggleFilters(false);
  }
}
